import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { closeDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import DOMPurify from 'dompurify';
import currencyFormatter from 'currency-formatter';

// Components
import * as icons from '../Icons/Icons';
import ScheduleTable from '../Modules/ScheduleTable';
import ScheduleDate from '../Modules/ScheduleDate';
import Payments from '../Payments/Payments';
import Counter from '../Counter/Counter';
import Pricing from './Pricing';
import BlackoutList from '../BlackoutDates/BlackoutList';
import ExamityRequirements from './ExamityRequirements';
import ProctorURequirements from './ProctorURequirements';

const ScheduleOnline = observer(class ScheduleOnline extends React.Component {
  constructor() {
    super();

    // Set initial state
    this.state = {
      step: 1,
      appointmentStartDate: null,
      appointmentEndDate: null,
      examSid: null,
      sessionSid: null,
      time: null,
      fees: null,
      voucherCode: null
    }
  }

  componentWillMount() {
    const { PaymentStore, ProctorStore, ScheduleStore } = this.props.store;
    ScheduleStore.onlineDate = null;

    this.props.store.SessionStore.getCurrentTime();

    if(!this.props.reschedule && !this.props.skipUrl) {
      this.setState({
        examSid: this.getSid(2),
        sessionSid: this.getSid(4)
      })
    } else {
      this.setState({
        examSid: this.props.examSid,
        sessionSid: this.props.sessionSid
      })
    }

    PaymentStore.setAfterPayment((event) => this.nextStep(event));

    // Reset any old schedule data
    ScheduleStore.resetData();

    // Check if there’s already a reservation
    const _this = this;
    setTimeout(function(){
      ScheduleStore.checkOnlineReservation(_this.state.examSid, _this.state.sessionSid, () => {_this.setStep(null, 4)}, _this);
    });

    if(!this.props.reschedule) {
      // Get the pricing data if we’re not rescheduling
      setTimeout(function(){
        const query = `?proctorLocationSids=${ProctorStore.proctorLocationSid}&examSessionSid=${_this.state.sessionSid}`;

        ProctorStore.searchProctors(query, _this.setFees, null, true, false, false);
      });
    } else {
      // Otherwise, just get the location data
      setTimeout(function(){
        const query = `?proctorLocationSids=${ProctorStore.proctorLocationSid}&examSessionSid=${_this.state.sessionSid}`;

        ProctorStore.searchProctors(query, _this.setLocation, null);
      });
    }
  }

  setLocation = (i, data) => {
    const { ScheduleStore } = this.props.store;

    ScheduleStore.onlineLocation = data[0].location.sid;
  }

  setFees = (i, data) => {
    const { ScheduleStore } = this.props.store;

    if(data[0] && data[0].fees && !data[0].fees.userTotal) {
      data[0].fees.userTotal = 0;
    }

    this.setState({
      fees: data[0].fees
    });

    // Store the online location sid
    ScheduleStore.onlineLocation = data[0].location.sid;
  }

  getSid = (segment) => {
    // Get the exam sid from the URL
    let pathname = '';

    if(typeof this.props !== 'undefined') {
      pathname = this.props.routing.location.pathname;
    } else {
      pathname = this.routing.location.pathname;
    }

    let pathArray = pathname.split('/');

    if (pathArray[0] === '') {
      pathArray.splice(0, 1);
    }

    const sid = pathArray[segment];

    return sid;
  }

  setStep = (e, step) => {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step
    }, function(){
      // Hide the close button on the last step so the
      // student has to click the return to dashboard button
      if(this.state.step === 7) {
        this.props.store.SessionStore.hideDrawerClose = true;
      }
    });
  }

  nextStep = (e) => {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step: this.state.step + 1
    });
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  isActive(step) {
    if(this.state.step === step) {
      return true;
    } else {
      return false;
    }
  }

  statusClass = (step) => {
    if(this.state.step === step) {
      return 'slide-active';
    } else if(this.state.step > step) {
      return 'slide-hidden-before';
    } else {
      return 'slide-hidden-after';
    }
  }

  setSlot = (appointmentStartDate, appointmentEndDate) => {
    this.setState({
      appointmentStartDate,
      appointmentEndDate
    });
  }

  confirmSlot = () => {
    const { ExamStore, ProctorStore, ScheduleStore } = this.props.store;
    const { duration } = ExamStore.examSession.examConfiguration;

    const data = {
      appointmentStartDateTime: this.state.appointmentStartDate,
      appointmentEndDateTime: this.state.appointmentEndDate,
      type: ProctorStore.proctors[0].location.schedulingModule,
      proctorLocationSid: this.props.proctorLocationSid
    }

    if(!data.appointmentEndDateTime) {
      data.appointmentEndDateTime = moment(data.appointmentStartDateTime).add(duration, 'minutes');
    }
    if(!this.props.reschedule) {
      if (data.type === 'smarter-scheduling') {
        // We have to first reserve an appointment if we are using SmarterScheduling
        ScheduleStore.createReservation(
          data,
          this.state.examSid,
          this.state.sessionSid,
          () => this.nextStep(null)
        );
      } else {
        this.nextStep(null);
      }
    } else {
      this.props.store.ScheduleStore.rescheduleAppointment(
        this.state.examSid,
        this.state.sessionSid,
        data,
        () => {this.setStep(null, 7)},
        () => {this.setStep(null, 9)}
      );
    }
  }

  submitSchedule = () => {
    const { ProctorStore, ScheduleStore } = this.props.store;

    const data = {
      appointmentDateTime: this.state.appointmentStartDate,
      amount: this.state.fees.userTotal,
      currency: this.state.fees.currencyCode,
      type: ProctorStore.proctors[0].location.schedulingModule,
      proctorLocationSid: ProctorStore.proctorLocationSid
    }

    ScheduleStore.createAppointment(this.state.examSid, this.state.sessionSid, data, () => {this.setStep(null, 7)});
  }

  renderPricingButton = () => {
    const { translation } = this.props;

    if(this.state.fees) {
      if(this.state.fees.userTotal > 0) {
        return (
          <button
            className="btn"
            onClick={(e) => {this.nextStep(e)}}
          >
            {translation.next}
          </button>
        )
      }

      if(this.state.fees.userTotal === 0) {
        return (
          <button
            className="btn"
            onClick={this.submitSchedule}
          >
            {translation.schedule}
          </button>
        )
      }
    }

    return null;
  }

  countdownExpired = () => {
    const { ScheduleStore } = this.props.store;

    ScheduleStore.resetData();

    const callback = () => {
      this.setStep(null, 8);
    }

    ScheduleStore.cancelReservation(this.state.examSid, this.state.sessionSid, callback);
  }

  startOver = () => {
    const { ScheduleStore } = this.props.store;

    ScheduleStore.checkOnlineReservation(
      this.state.examSid,
      this.state.sessionSid,
      () => {this.setStep(null, 1)},
      this
    );
  }

  render() {
    const { store, translation } = this.props;
    const { ProctorStore, ScheduleStore, SessionStore, StudentStore } = store;
    const { userTimezone } = this.props.store.SessionStore;

    if(!SessionStore.loading || ScheduleStore.onlineAvailability.length > 0) {
      // If we are using smarter-scheduling, we want to skip the payment screen
      // as the pricing is already on the location
      const schedulingModule =
        ProctorStore.proctors &&
        ProctorStore.proctors[0] &&
        ProctorStore.proctors[0].location &&
        ProctorStore.proctors[0].location.schedulingModule ?
          ProctorStore.proctors[0].location.schedulingModule :
          null;
      if (schedulingModule === 'smarter-scheduling' && this.state.step === 1) {
        this.setStep(null, 2);
      }

      return(
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.intro.heading}</h1>

              {ScheduleStore.externalReservedAppointmentExpires &&
                <Counter
                  endDate={ScheduleStore.externalReservedAppointmentExpires}
                  callback={this.countdownExpired}
                  {...this.props}
                />
              }
            </div>
          </header>

          <div className="slide-wrap slide-wrap--sticky wrap">
            <div className={`panel panel--medium ${this.statusClass(1)}`}>
              {
                this.state.step === 1 &&
                schedulingModule === 'examity' &&
                <img className="panel__img" src="./static/img/logo-examity.png" width="200" alt="Examity" />
              }

              {
                this.state.step === 1 &&
                schedulingModule === 'proctoru' &&
                <img className="panel__img" src="./static/img/logo-proctoru.png" width="200" alt="ProctorU" />
              }

              {this.state.step === 1 &&
                <div
                  className="schedule-intro"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                      translation.intro.body[schedulingModule]
                    )
                  }}
                ></div>
              }

              {
                this.state.step === 1 &&
                schedulingModule === 'examity' &&
                <ExamityRequirements {...this.props} />
              }

              {
                this.state.step === 1 &&
                schedulingModule === 'proctoru' &&
                <ProctorURequirements {...this.props} />
              }

              {this.state.step === 1 && this.state.fees &&
                <div className="note">
                  <p>
                    <strong>{translation.intro.pricing.heading}</strong>
                  </p>

                  <p>
                    {translation.intro.pricing.total} <strong>
                      {currencyFormatter.format(
                        this.state.fees.userTotal,
                        {code: this.state.fees.currencyCode})
                      } {this.state.fees.currencyCode}
                    </strong>
                  </p>

                  <p>{translation.intro.pricing.body}</p>
                </div>
              }

              <button className="btn" onClick={(e) => {this.nextStep(e)}}>
                <icons.iconCalendar />
                {translation.intro.button}
              </button>
            </div>

            <div className={`panel panel--large media--alt media--alt-top ${this.statusClass(2)}`}>

              {/* Date picker */}
              <ScheduleDate
                combined={false}
                setStep={this.setStep}
                {...this.props}
                examSid={this.state.examSid}
                sessionSid={this.state.sessionSid}
                step={this.state.step}
              />

              {/* Select date message */}
              {!ScheduleStore.onlineDate && ScheduleStore.onlineAvailability.length === 0 &&
                <div className="media__copy">
                  <BlackoutList {...this.props} />

                  <p
                    className="note"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(translation.intro.time_note)
                    }}
                  ></p>

                  <span className="no-results">{translation.select_date}</span>
                </div>
              }

              {/* Availability list */}
              {(ScheduleStore.onlineDate || ScheduleStore.onlineAvailability.length > 0) &&
                <div className="media__copy">
                  <BlackoutList {...this.props} />

                  <ScheduleTable
                    combined={false}
                    setStep={this.setStep}
                    getSid={this.getSid}
                    routing={this.props.routing}
                    setSlot={this.setSlot}
                    parent={this}
                    {...this.props}
                    sessionSid={this.state.sessionSid}
                  />
                </div>
              }
            </div>

            <div className={`panel panel--brief ${this.statusClass(4)}`}>
              <h2 className="panel__title">{translation.confirm.heading}</h2>

              <p>{translation.confirm.body_pre}</p>

              <time className="text-code">
                {moment(this.state.appointmentStartDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')}
              </time>

              <p>{translation.confirm.body_post}</p>

              <button
                className="btn"
                onClick={this.confirmSlot}
              >
                <icons.iconCalendarPlus />
                {translation.confirm.button}
              </button>

              <span className="preposition--vertical">{translation.confirm.or}</span>

              <button
                className="btn--link"
                onClick={(e) => this.setStep(e, 2)}
              >
                {translation.confirm.change_time}
              </button>
            </div>

            <div className={`panel panel--brief ${this.statusClass(5)}`}>
              <Pricing fees={this.state.fees} scheduler={this} {...this.props} />

              {this.renderPricingButton()}

              <span className="preposition--vertical">{translation.confirm.or}</span>

              <button
                className="btn--link"
                onClick={(e) => this.setStep(e, 4)}
              >
                {translation.go_back}
              </button>
            </div>

            <div className={`panel panel--brief ${this.statusClass(6)}`}>
              <h2 className="panel__title">{translation.payment.heading}</h2>

              <Payments submit={this.submitSchedule} {...this.props} />
            </div>

            <div className={`panel panel--brief ${this.statusClass(7)}`}>
              <h2 className="panel__title">{translation.confirmed.heading}!</h2>

              <p>{translation.confirmed.body}</p>

              <time className="text-code">
                {moment(this.state.appointmentStartDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')}
              </time>

              <a
                className="btn btn--icn-right"
                href="#app"
                onClick={(e) => {closeDrawer(e, this.props.parent, '/', StudentStore.getStudentExams)}}
              >
                {translation.confirmed.button}
                <icons.iconCircleRight />
              </a>
            </div>

            <div className={`panel panel--brief ${this.statusClass(8)}`}>
              <h2 className="panel__title">{translation.expired.heading}</h2>

              <p>{translation.expired.body}</p>

              <button
                className="btn btn--icn-right"
                onClick={this.startOver}
              >
                {translation.expired.button}
                <icons.iconCircleRight />
              </button>
            </div>

            <div className={`panel panel--brief ${this.statusClass(9)}`}>
              <h2 className="panel__title">{translation.refresh.heading}</h2>

              <p>{translation.refresh.body}</p>

              <a
                className="btn btn--icn-right"
                href="#app"
                onClick={(e) => {closeDrawer(e, this.props.parent, '/', StudentStore.getStudentExams)}}
              >
                {translation.confirmed.button}
                <icons.iconCircleRight />
              </a>
            </div>
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('ScheduleOnline')(ScheduleOnline);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/ScheduleOnline.js